<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <q-form ref="editForm">
          <c-card class="cardClassDetailForm" title="인허가 요청정보">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="editable && isStepReq1 && isRequestUser"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
                <c-btn
                  v-if="editable && param.limLicenseRequestId && isStepReq && isRequestUser"
                  label="요청완료"
                  icon="save"
                  @btnClicked="saveEnd"/>
                <c-btn
                  v-if="editable && param.limLicenseRequestId && isDelete && isRequestUser"
                  label="삭제"
                  icon="delete_forever"
                  @btnClicked="deleteData"/>
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-9">
                <c-text
                  :required="true"
                  :editable="editable"
                  label="인허가 요청명"
                  name="licenseRequestName"
                  v-model="data.licenseRequestName">
                </c-text>
              </div>
              <div class="col-3">
                <c-plant
                  :required="true"
                  :editable="editable"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
              <div class="col-3">
                <c-field
                  :editable="editable"
                  :disabled="true"
                  :data="data"
                  deptValue="requestDeptCd"
                  type="dept_user"
                  label="요청부서 & 요청자"
                  name="requestUserId"
                  v-model="data.requestUserId">
                </c-field>
              </div>
              <div class="col-3">
                <c-field
                  :required="true"
                  :editable="editable"
                  :data="data"
                  deptValue="reviewDeptCd"
                  type="dept_user"
                  label="검토부서 & 검토자"
                  name="reviewUserId"
                  v-model="data.reviewUserId">
                </c-field>
              </div>
              <div class="col-3">
                <c-datepicker
                  :required="true"
                  :editable="editable"
                  label="인허가 완료 요청일"
                  name="completeRequestDate"
                  v-model="data.completeRequestDate">
                </c-datepicker>
              </div>
              <div class="col-3">
                <c-text
                  :afterIcon="editable ? [
                    { name: 'search', click: true, callbackName: 'searchMoc', color: 'teal' },
                    { name: 'close', click: true, callbackName: 'removeMoc', color: 'red' }
                  ] : null"
                  :editable="editable"
                  :disabled="true"
                  label="MOC번호"
                  name="sopMocId"
                  v-model="data.sopMocId"
                  @searchMoc="searchMoc"
                  @removeMoc="removeMoc" />
              </div>
              <div class="col-12">
                <c-textarea
                  label="요청 내용"
                  :editable="editable"
                  name="requestContent"
                  :rows="2"
                  v-model="data.requestContent" />
              </div>
              <div class="col-3">
                <c-select
                  :disabled="true"
                  codeGroupCd="LICENSE_REQUEST_STEP_CD"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="requestStepCd"
                  label="진행단계"
                  v-model="data.requestStepCd"
                ></c-select>
              </div>
              <div class="col-9">
                <c-textarea
                  v-show="data.requestStepCd == 'RSC0999999'"
                  label="기각사유"
                  :editable="false"
                  name="dismissReason"
                  :rows="1"
                  v-model="data.dismissReason" />
              </div>
            </template>
          </c-card>
        </q-form>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7" v-if="param.limLicenseRequestId">
        <c-table
          ref="table"
          title="인허가 검토 목록"
          tableId="table"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :columns="grid.columns"
          :data="grid.data"
          @rowClick="rowClick"
          gridHeight="300px"
        ></c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" v-if="param.limLicenseRequestId">
        <q-form ref="editForm2">
          <c-card title="인허가 검토 상세" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn v-if="editable && data.requestStepCd=='RSC0000001'" label="신규" icon="add" @btnClicked="addReview" />
                <c-btn
                  v-if="editable && saveable && data.requestStepCd=='RSC0000001'"
                  :url="saveReviewUrl"
                  :isSubmit="isReviewSave"
                  :param="dataReview"
                  :mappingType="saveReviewType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveReview"
                  @btnCallback="saveReviewCallback" />
                <c-btn
                  v-if="editable && deleteable && data.requestStepCd=='RSC0000001'"
                  label="삭제"
                  icon="delete_forever"
                  @btnClicked="deleteReview"/>
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <c-text
                  :required="true"
                  :editable="false"
                  label="관련법규"
                  name="relatedLawsName"
                  v-model="dataReview.relatedLawsName">
                </c-text>
              </div>
              <div class="col-6">
                <c-text
                  :required="true"
                  :afterIcon="editable ? [
                    { name: 'search', click: true, callbackName: 'searchLicenseKindId', color: 'teal' },
                    { name: 'close', click: true, callbackName: 'removeLicenseKindId', color: 'red' }
                  ] : null"
                  :editable="editable && dataeditable"
                  :readonly="true"
                  label="인허가종류"
                  name="limLicenseKindName"
                  v-model="dataReview.limLicenseKindName"
                  @searchLicenseKindId="searchLicenseKindId"
                  @removeLicenseKindId="removeLicenseKindId">
                </c-text>
              </div>
              <div class="col-6">
                <c-field
                  :required="true"
                  :editable="editable && dataeditable"
                  :data="dataReview"
                  deptValue="reviewDeptCd"
                  type="dept_user"
                  label="검토담당부서 & 검토담당자"
                  name="reviewUserId"
                  v-model="dataReview.reviewUserId">
                </c-field>
              </div>
              <div class="col-6">
                <c-select
                  :disabled="true"
                  :editable="editable && dataeditable"
                  codeGroupCd="LIM_LICENSE_KIND_STAUS_CD"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="limLicenseKindStatusCd"
                  label="검토상태"
                  v-model="dataReview.limLicenseKindStatusCd"
                ></c-select>
              </div>
              <div class="col-6">
                <c-checkbox
                  :editable="editable && dataeditable"
                  :isFlag="true"
                  label="갱신 여부"
                  name="renewalFlag"
                  v-model="dataReview.renewalFlag"
                />
              </div>
              <div class="col-6">
                <c-text
                  v-if="dataReview.renewalFlag == 'Y'"
                  :required="dataReview.renewalFlag == 'Y'"
                  :afterIcon="editable ? [
                    { name: 'search', click: true, callbackName: 'searchLicenseId', color: 'teal' },
                    { name: 'close', click: true, callbackName: 'removeLicenseId', color: 'red' }
                  ] : null"
                  :editable="editable && dataeditable"
                  :readonly="true"
                  label="갱신대상 인허가"
                  name="asLicenseSeqName"
                  v-model="dataReview.asLicenseSeqName"
                  @searchLicenseId="searchLicenseId"
                  @removeLicenseId="removeLicenseId">
                </c-text>
              </div>
            </template>
          </c-card>
        </q-form>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: "license-request-detail",
  props: {
    param: {
      type: Object,
      default: () => ({
        limLicenseRequestId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      saveUrl: transactionConfig.sop.lim.lincense.request.insert.url,
      mappingType: 'POST',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      saveable: false,
      deleteable: false,
      editable: true,
      dataeditable: false,
      isSave: false,
      isSaveEnd: false,
      isStepReq: false,
      isStepReq1: false,
      isDelete: false,
      isRequestUser: false,
      isReviewSave: false,
      detailReviewUrl: '',
      reviewlistUrl: '',
      reviewinsertUrl: '',
      reviewupdateUrl: '',
      reviewdeleteUrl: '',
      saveReviewUrl: transactionConfig.sop.lim.lincense.review.insert.url,
      saveReviewType: 'POST',
      isReviewUser: false,
      isReqReviewUser: false,
      data: {
        limLicenseRequestId: '',  // 인허가 요청 일련번호
        plantCd: '',  // 사업장 코드
        licenseRequestName: '',  // 인허가 요청명
        requestDeptCd: '',  // 요청부서 코드
        requestUserId: '',  // 요청자
        completeRequestDate: '',  // 인허가 완료 요청일
        requestContent: '',  // 요청 내용
        sopMocId: '',  // MOC 일련번호
        requestStepCd: 'RSC0000001',  // 요청및검토 진행 단계 : RSC0000002(요청),RSC0000003(검토 및 진행중),RSC0999999(기각),RSC1000000(완료)
        dismissReason: '',  // 기각사유
        reviewOpinion: '',  // 검토 종합 의견
        reviewUserId: '',  // 종합 검토자
        reviewDeptCd: '',  // 검토 부서
        regUserId: '',  // 등록자
        chgUserId: '',  // 수정자
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      dataReview: {
        limLicenseReviewId: '',  // 인허가 검토 일련번호
        limLicenseRequestId: '',  // 인허가 요청 일련번호
        limLicenseKindId: '',  // 인허가종류 알련번호
        limLicenseKindName: '',
        relatedLawsName: '',
        renewalFlag: 'N',  // 갱신 여부, 갱신인 경우는 기존인허가번호 입력
        reviewDeptCd: '',  // 검토부서
        reviewUserId: '',  // 검토자
        reviewOpinion: '',  // 인허가 검토 의견
        reviewCompleteFlag: 'N',  // 검토완료 여부
        limLicenseKindStatusCd: null,  // 인허가종류별 검토상태
        asLicenseSeq: '',  // 기존 인허가 일련번호
        asLicenseSeqName: '',  // 기존 인허가명
        newLicenseSeq: '',  // 등록 인허가 일련번호
        regUserId: '',  // 등록자
        chgUserId: '',  // 수정자
      },
      grid: {
        columns: [
          {
            name: 'relatedLawsName',
            field: 'relatedLawsName',
            label: '관련법규',
            align: 'center',
            sortable: true,
          },
          {
            name: 'limLicenseKindName',
            field: 'limLicenseKindName',
            label: '인허가종류',
            align: 'center',
            sortable: true,
          },
          {
            name: 'reviewDeptName',
            field: 'reviewDeptName',
            label: '검토부서',
            align: 'center',
            sortable: true,
          },
          {
            name: 'reviewUserName',
            field: 'reviewUserName',
            label: '검토자',
            align: 'center',
            sortable: true,
          },
          {
            name: 'limLicenseKindStatusName',
            field: 'limLicenseKindStatusName',
            label: '검토상태',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sop.lim.lincense.request.get.url;
      this.insertUrl = transactionConfig.sop.lim.lincense.request.insert.url;
      this.updateUrl = transactionConfig.sop.lim.lincense.request.update.url;
      this.deleteUrl = transactionConfig.sop.lim.lincense.request.delete.url;

      this.reviewlistUrl = selectConfig.sop.lim.lincense.review.list.url;
      this.detailReviewUrl = selectConfig.sop.lim.lincense.review.get.url;
      this.reviewinsertUrl = transactionConfig.sop.lim.lincense.review.insert.url;
      this.reviewupdateUrl = transactionConfig.sop.lim.lincense.review.update.url;
      this.reviewdeleteUrl = transactionConfig.sop.lim.lincense.review.delete.url;
      this.dataeditable = false;
      this.getData();
      this.getList();
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1')[0];
      if (_table) {
        _table.classList.remove('bg-light-blue-1');
      }
    },
    getReviewList() {
      this.getList();
      this.rowRemoveSelect();
      this.reset();
    },
    getList() {
      this.$http.url = this.reviewlistUrl;
      this.$http.type = 'GET';
      this.$http.param = {limLicenseRequestId: this.param.limLicenseRequestId};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
      this.saveable = false;
      this.deleteable = false;
    },
    rowClick(row) {
      // 상세조회
      this.saveable = true;
      this.deleteable = true;
      this.updateMode = true;
      this.$http.url = this.$format(this.detailReviewUrl, row.limLicenseReviewId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.dataReview = _result.data;
        this.saveReviewUrl = this.reviewupdateUrl;
        this.saveReviewType = 'PUT';
        this.dataeditable = true;
      },
      () => {
      });
    },
    addReview() {
      this.saveable = true;
      this.deleteable = false;
      this.saveReviewUrl = this.reviewinsertUrl;
      this.saveReviewType = 'POST';
      this.updateMode = false;
      this.dataReview = {
        limLicenseReviewId: '',  // 인허가 검토 일련번호
        limLicenseRequestId: this.param.limLicenseRequestId,  // 인허가 요청 일련번호
        limLicenseKindId: '',  // 인허가종류 알련번호
        limLicenseKindName: '',
        relatedLawsName: '',
        renewalFlag: 'N',  // 갱신 여부, 갱신인 경우는 기존인허가번호 입력
        reviewDeptCd: '',  // 검토부서
        reviewUserId: '',  // 검토자
        reviewOpinion: '',  // 인허가 검토 의견
        reviewCompleteFlag: 'N',  // 검토완료 여부
        limLicenseKindStatusCd: 'LLKSC00001',  // 인허가종류별 검토상태
        asLicenseSeq: '',  // 기존 인허가 일련번호
        asLicenseSeqName: '',  // 기존 인허가명
        newLicenseSeq: '',  // 등록 인허가 일련번호
        regUserId: '',  // 등록자
        chgUserId: '',  // 수정자
      };
      this.dataeditable = true;
      this.rowRemoveSelect();
    },
    reset() {
      this.rowRemoveSelect();
      this.saveable = false;
      this.deleteable = false;
      this.updateMode = false;
      this.dataeditable = false;
      this.dataReview = {
        limLicenseReviewId: '',  // 인허가 검토 일련번호
        limLicenseRequestId: this.param.limLicenseRequestId,  // 인허가 요청 일련번호
        limLicenseKindId: '',  // 인허가종류 알련번호
        limLicenseKindName: '',
        relatedLawsName: '',
        renewalFlag: 'N',  // 갱신 여부, 갱신인 경우는 기존인허가번호 입력
        reviewDeptCd: '',  // 검토부서
        reviewUserId: '',  // 검토자
        reviewOpinion: '',  // 인허가 검토 의견
        reviewCompleteFlag: 'N',  // 검토완료 여부
        limLicenseKindStatusCd: null,  // 인허가종류별 검토상태
        asLicenseSeq: '',  // 기존 인허가 일련번호
        asLicenseSeqName: '',  // 기존 인허가명
        newLicenseSeq: '',  // 등록 인허가 일련번호
        regUserId: '',  // 등록자
        chgUserId: '',  // 수정자
      };
    },
    saveReview() {
      this.$refs['editForm2'].validate().then(_result => {
        // 중복체크
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.dataReview.regUserId = this.$store.getters.user.userId;
              this.dataReview.chgUserId = this.$store.getters.user.userId;
              if (this.dataReview.renewalFlag == 'N') {
                this.dataReview.asLicenseSeq = '';
                this.dataReview.asLicenseSeqName = '';
              }
              this.isReviewSave = !this.isReviewSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteReview() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.dataReview.limLicenseReviewId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.getList();
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveReviewCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.saveType == 'PUT') {
        this.getList();
        this.rowClick({ limLicenseRequestId: result.data.limLicenseRequestId })
      } else {
        this.getReviewList();
      }
    },
    getData() {
      if (this.param.limLicenseRequestId) {
        this.$http.url = this.$format(this.detailUrl, this.param.limLicenseRequestId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = _result.data;
          if (this.data.requestStepCd == 'RSC0000001') { // 작성중
            this.isStepReq = true;
            this.isStepReq1 = true;
          } else {
            this.isStepReq1 = false;
          }
          if (this.data.requestStepCd == 'RSC0000002') { // 요청완료
            this.isStepReq = false;
          }
          if (this.data.requestStepCd == 'RSC0000003' || this.data.requestStepCd == 'RSC1000000') {
            this.isDelete = false;
          } else {
            this.isDelete = true;
          }
          // 요청자나 요청부서원일 경우 버튼실행 가능
          if (this.data.requestUserId == this.$store.getters.user.userId || this.data.requestDeptCd == this.$store.getters.user.deptCd) {
            this.isRequestUser = true;
          }
        },);
      } else {
        this.isRequestUser = true;
        this.isStepReq = false;
        this.isStepReq1 = true;
        this.data.requestDeptCd = this.$store.getters.user.deptCd;  // 요청부서 코드
        this.data.requestUserId = this.$store.getters.user.userId;  // 요청자
      }
    },
    saveData() {
      if (this.param.limLicenseRequestId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      let saveMsg = '저장하시겠습니까?';
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: saveMsg,
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveEnd() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '인허가요청을 하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'warning', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.requestStepCd = 'RSC0000002';
              this.data.chgUserId = this.$store.getters.user.userId;

              this.$http.url = this.updateUrl;
              this.$http.type = 'PUT';
              this.$http.param = this.data
              this.$http.request(() => {
                this.getData();
                window.getApp.$emit('APP_REQUEST_SUCCESS');
              },);
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteData() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '인허가요청을 삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.param.limLicenseRequestId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.$emit('APP_REQUEST_SUCCESS');
            this.$emit('emitStep', {
              name: 'closePopup'
            })
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.mappingType == 'POST') {
        this.param.limLicenseRequestId = result.data.limLicenseRequestId
      }
      this.getData();
    },
    searchMoc() {
      this.popupOptions.title = 'MOC 검색'; // MOC 검색
      this.popupOptions.param = {
        type: 'single'
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/moc/mocPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeMocPopup;
    },
    closeMocPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data) {
        this.data.sopMocId = data.chngNum
      }
    },
    removeMoc() {
      this.data.sopMocId = null
    },
    searchLicenseKindId() {
      this.popupOptions.title = '관련법규/인허가종류 검색'; // 관련법규/인허가종류 검색
      this.popupOptions.param = {
        type: 'single',
        chkPlantCd: this.data.plantCd, // 사업장번호를 넘기면 갱신대상인지 신규대상인지 확인
      };
      this.popupOptions.target = () => import(`${'@/pages/common/license/licenseKindPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeLicenseKindId;
    },
    closeLicenseKindId(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.dataReview.relatedLawsName = data[0].relatedLawsName;
        this.dataReview.limLicenseKindId = data[0].limLicenseKindId;
        this.dataReview.limLicenseKindName = data[0].limLicenseKindName;
        this.dataReview.renewalFlag = data[0].renewalFlag;
        this.dataReview.asLicenseSeq = data[0].asLicenseSeq;
        this.dataReview.asLicenseSeqName = data[0].asLicenseSeqName;
      }
    },
    removeLicenseKindId() {
      this.dataReview.relatedLawsName = '';
      this.dataReview.limLicenseKindId = '';
      this.dataReview.limLicenseKindName = '';
    },
    searchLicenseId() {
      this.popupOptions.title = '인허가현황 검색'; // 관련법규/인허가종류 검색
      this.popupOptions.param = {
        type: 'single',
      };
      this.popupOptions.target = () => import(`${'@/pages/common/license/licensePop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeLicenseId;
    },
    closeLicenseId(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.dataReview.asLicenseSeqName = data[0].limLicenseKindName;
        this.dataReview.asLicenseSeq = data[0].limLicenseKindId;
      }
    },
    removeLicenseId() {
      this.dataReview.asLicenseSeq = '';
      this.dataReview.asLicenseSeqName = '';
    },
  }
};
</script>
